import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Cookies from "js-cookie";
import Swal from 'sweetalert2';
import { AMPMDATETIME, urlMappings } from '../../HelperFunctions';
import { toast } from 'react-toastify';
import { adminMainUrl } from '../../Config';
import axios from 'axios';
const Navbar = ({ setShowMenu, showMenu, showSideNavBar, refreshNotification, notificationData, CompanyDetailData, loadingCompanyDetail }) => {

    const { sidebarPermissionHRMSData } = useSelector(state => state?.NavbarReducer || {});

    const [notificationCount, setNotificationCount] = useState(false);
    const [notificationArr, setNotificationArr] = useState([]);

    let [HRMS_URL, setHRMS_URL] = useState("https://committedhrms.flexichains.com");

    const currentUrl = window.location.origin;
    useEffect(() => {
        if (currentUrl) {
            // console.log(currentUrl);
            const mapping = urlMappings.find(entry => entry.frontend === currentUrl);
            if (mapping && mapping.hrms_url) {
                setHRMS_URL(mapping.hrms_url);
            }
        }
    }, [currentUrl])

    useEffect(() => {
        if (notificationData) {
            setNotificationArr(notificationData);

            let filterUnread = notificationData.filter(v => v.is_read == false);
            setNotificationCount(filterUnread.length);
        }
    }, [notificationData])

    const [dropdown1, setDropdown1] = useState(false)
    const [layoutBs, setLayoutBs] = useState(localStorage.getItem("dataTheme"));
    const LayoutDark = () => {
        localStorage.setItem("dataTheme", "dark");
        document.documentElement.setAttribute("data-theme", "dark");
        setLayoutBs("dark");
    };
    const LayoutLight = () => {
        localStorage.setItem("dataTheme", "light");
        document.documentElement.setAttribute("data-theme", "light");
        setLayoutBs("light");
    };
    const navigate = useNavigate();
    const handleLogout = () => {
        // Trigger SweetAlert
        Swal.fire({
            title: 'Are you sure?',
            text: "You will be logged out!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, log out!'
        }).then((result) => {
            if (result.isConfirmed) {
                // If user confirms, remove the token and navigate to login
                Cookies.remove('token');
                Cookies.remove('flexichain_user_id');
                navigate('/login');
                Swal.fire(
                    'Logged Out!',
                    'You have been logged out successfully.',
                    'success'
                );
            }
        });
    };

    let platformURLs = [
        { name: "Dashboard", url: '/flexichain/dashboard' },
        { name: "Employee", url: '/flexichain/all-employee-list' },
        { name: "Roles", url: '/flexichain/role-permission' },
        { name: "Create Quote", url: '/flexichain/quote-form' },
        { name: "Quote List", url: '/flexichain/all-query-list' },
        { name: "Picked Leads", url: '/flexichain/picked-leads' },
        { name: "Converted Leads", url: '/flexichain/converted-leads' },
        { name: "Not Converted Leads", url: '/flexichain/non-converted-leads' },
        { name: "Rate Request", url: '/flexichain/import-rate-request' },
        { name: "Picked Rate Request", url: '/flexichain/import-picked-rate-request' },
        { name: "Send Pricing", url: '/flexichain/import-send-pricing-list' },
    ];


    const [searchTerm, setSearchTerm] = useState('');
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [highlightedIndex, setHighlightedIndex] = useState(-1);

    // const navigate = useNavigate(); // Replaces useHistory

    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);

        if (value) {
            // Filter platform URLs based on the search term
            const filtered = platformURLs.filter(option =>
                option.name.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredOptions(filtered);
            setHighlightedIndex(-1); // Reset highlight when typing
        } else {
            setFilteredOptions([]);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'ArrowDown') {
            setHighlightedIndex((prevIndex) =>
                Math.min(prevIndex + 1, filteredOptions.length - 1)
            );
        } else if (e.key === 'ArrowUp') {
            setHighlightedIndex((prevIndex) => Math.max(prevIndex - 1, 0));
        } else if (e.key === 'Enter' && highlightedIndex !== -1) {
            handleSelect(filteredOptions[highlightedIndex]);
        }
    };

    const handleSelect = (option) => {
        setSearchTerm(option.name); // Set the selected name to the input
        setFilteredOptions([]); // Hide the dropdown

        // Navigate to the selected URL using useNavigate
        navigate(option.url);
    };

    let config = {
        headers: {
            'auth-token': Cookies.get('token'),
            'user_id': Cookies.get('flexichain_user_id')
        }
    };

    function checkOpenWindowURLs(url) {
        // Strings to check for
        const stringsToCheck = ["query-information", "query-import-give-rate"];

        // Check if any of the strings are included in the URL
        return stringsToCheck.some((str) => url.includes(str));
    }
    const openNewWindow = (url) => {
        try {
            const newWindow = window.open(
                url, // URL of the new window
                '_blank', // Target window name
                'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1000,height=600' // Window features
            );

            if (newWindow) {
                const interval = setInterval(() => {
                    if (newWindow && newWindow.closed) {
                        clearInterval(interval);
                        // refreshData();
                    }
                }, 500);
                return newWindow;
            } else {
                // If popup blocker suppressed window.open, navigate directly
                navigate(url);
                return null;
            }
        } catch (e) {
            console.error("Popup window error:", e);
            navigate(url);
            return null;
        }
    };

    const readNotification = (id, url, notifObj) => {
        try {
            let targetUrl = url;
            if (targetUrl && targetUrl.includes('query-information')) {
                const isPricingNotif = notifObj?.notification?.toLowerCase()?.includes('pricing');
                const hasSales = sidebarPermissionHRMSData?.modules?.some(m => (m?.short_name === 'sales_and_crm' || m?.name?.toLowerCase() === 'sales & crm') && m?.assign_module_role);
                const hasPricing = sidebarPermissionHRMSData?.modules?.some(m => (m?.short_name === 'pricing' || m?.name?.toLowerCase() === 'pricing') && m?.assign_module_role);
                if (isPricingNotif || (!hasSales && hasPricing)) {
                    targetUrl = targetUrl.replace('query-information', 'query-import-give-rate');
                }
            }

            // Open window synchronously in the user gesture click handler to prevent popup blocking
            if (targetUrl) {
                checkOpenWindowURLs(targetUrl) ?
                    openNewWindow(targetUrl)
                    :
                    navigate(targetUrl);
            }

            // Mark notification as read in parallel
            axios.get(`${adminMainUrl}/api/notification/read?notification_id=${id}`, config)
                .then(res => {
                    if (res.status == 200) {
                        refreshNotification();
                    } else {
                        toast.error(res.data?.msg);
                    }
                }).catch(err => {
                    console.log(err);
                    toast.error(err?.response?.data?.msg || err?.message);
                });
        } catch (error) {
            toast.error(error.message);
        }
    };

    const readAllNotifications = () => {
        try {
            axios.get(`${adminMainUrl}/api/notification/readall`, config)
                .then(res => {
                    if (res.status == 200) {
                        refreshNotification();
                    } else {
                        toast.error(res.data.msg);
                    }
                }).catch(err => {
                    console.log(err);
                    toast.error(err.response.data.msg);
                })
        } catch (error) {
            toast.error(error.message);
        }
    }

    const deleteAllNotifications = () => {
        try {
            axios.get(`${adminMainUrl}/api/notification/deleteall`, config)
                .then(res => {
                    if (res.status == 200) {
                        refreshNotification();
                    } else {
                        toast.error(res.data.msg);
                    }
                }).catch(err => {
                    console.log(err);
                    toast.error(err.response.data.msg);
                })
        } catch (error) {
            toast.error(error.message);
        }
    }

    return (
        <div className="header">
            {/* Logo */}
            <div className="header-left active">
                <a href="#" className="logo logo-normal">

                    {/* <img className="logo-side" src="/assets/img/logo-side.png" /> */}

                    <img className="logo-side company-logo-flexichain"
                        src={CompanyDetailData ? CompanyDetailData.logo_path : "/assets/img/logo.png"}
                        alt=""
                        onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = "/assets/img/logo.png";
                        }}
                    />

                    {/* <img src="./assets/img/logo.svg" alt="Logo" /> */}
                    <img
                        // src="/assets/img/white-logo.svg"
                        src={CompanyDetailData ? CompanyDetailData.logo_path : "/assets/img/white-logo.svg"}
                        className="white-logo"
                        alt="Logo"
                        onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = "/assets/img/logo.png";
                        }}
                    />
                </a>
                <a href="/flexichain/dashboard" className="logo-small company-logo-flexichain">
                    <img
                        src={CompanyDetailData ? CompanyDetailData.logo_path : "/assets/img/logo.png"}
                        alt="Logo"
                        onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = "/assets/img/logo.png";
                        }}
                    />
                </a>
                <a id="toggle_btn" href="javascript:void(0);">
                    <i className="ti ti-arrow-bar-to-left" />
                </a>
            </div>
            {/* /Logo */}
            <a id="mobile_btn" className="mobile_btn" onClick={() => {
                setShowMenu(!showMenu)
            }}>
                <span className="bar-icon">
                    <span />
                    <span />
                    <span />
                </span>
            </a>
            <div className="header-user">
                <ul className="nav user-menu">
                    {/* Search */}
                    <li className="nav-item nav-search-inputs me-auto">
                        <div className="top-nav-search">
                            <a href="javascript:void(0);" className="responsive-search">
                                <i className="fa fa-search" />
                            </a>
                            <form action="#" className="dropdown">
                                {/* <div className="searchinputs" id="dropdownMenuClickable">
                                    <input type="text" placeholder="Search"
                                    // value={searchTerm}
                                    // onChange={handleInputChange}
                                    // onKeyDown={handleKeyDown}
                                    />
                                    <div className="search-addon">
                                        <button type="submit">
                                            <i className="ti ti-command" />
                                        </button>
                                    </div>
                                </div> */}
                                {searchTerm && filteredOptions.length > 0 && (
                                    <ul className="dropdown-list">
                                        {filteredOptions.map((option, index) => (
                                            <li
                                                key={option.url}
                                                className={highlightedIndex === index ? 'highlighted' : ''}
                                                onClick={() => handleSelect(option)}
                                            >
                                                {option.name}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </form>
                        </div>
                    </li>
                    {/* /Search */}
                    {/* Nav List */}
                    <li className="nav-item nav-list">
                        <ul className="nav">
                            {/* <li className="dark-mode-list">
                                <a
                                    href="javascript:void(0);"
                                    id="dark-mode-toggle"
                                    className="dark-mode-toggle"
                                >
                                    <i className="ti ti-sun light-mode active" />
                                    <i className="ti ti-moon dark-mode" />
                                </a>
                            </li> */}
                            <li className="dark-mode-list">

                                <Link
                                    to="#"
                                    className={`dark-mode-toggle ${layoutBs ? "" : "active"}`}
                                    id="dark-mode-toggle"
                                >
                                    <i
                                        className={`ti ti-sun light-mode ${layoutBs === "dark" ? "" : "active"
                                            }`}
                                        onClick={LayoutLight}
                                    >
                                        {" "}
                                    </i>
                                    <i
                                        className={`ti ti-moon dark-mode ${layoutBs === "dark" ? "active" : ""
                                            }`}
                                        onClick={LayoutDark}
                                    ></i>
                                </Link>
                            </li>
                            {/* <li className="nav-item dropdown">
                                <a
                                    href="javascript:void(0);"
                                    className="btn btn-header-list"
                                    data-bs-toggle="dropdown"
                                >
                                    <i className="ti ti-layout-grid-add" />
                                </a>
                                <div className="dropdown-menu dropdown-menu-end menus-info">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <ul className="menu-list">
                                                <li>
                                                    <a href="#">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-violet">
                                                                <i className="ti ti-user-up" />
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Contacts</p>
                                                                <span>Add New Contact</span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-green">
                                                                <i className="ti ti-timeline-event-exclamation" />
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Pipline</p>
                                                                <span>Add New Pipline</span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-pink">
                                                                <i className="ti ti-bounce-right" />
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Activities</p>
                                                                <span>Add New Activity</span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-info">
                                                                <i className="ti ti-analyze" />
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Analytics</p>
                                                                <span>Shows All Information</span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-danger">
                                                                <i className="ti ti-atom-2" />
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Projects</p>
                                                                <span>Add New Project</span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col-md-6">
                                            <ul className="menu-list">
                                                <li>
                                                    <a href="#">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-info">
                                                                <i className="ti ti-medal" />
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Deals</p>
                                                                <span>Add New Deals</span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-secondary">
                                                                <i className="ti ti-chart-arcs" />
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Leads</p>
                                                                <span>Add New Leads</span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-tertiary">
                                                                <i className="ti ti-building-community" />
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Company</p>
                                                                <span>Add New Company</span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-success">
                                                                <i className="ti ti-list-check" />
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Tasks</p>
                                                                <span>Add New Task</span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-purple">
                                                                <i className="ti ti-brand-campaignmonitor" />
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Campaign</p>
                                                                <span>Add New Campaign</span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="nav-item">
                                <a href="#" className="btn btn-help">
                                    <i className="ti ti-help-hexagon" />
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="#" className="btn btn-chart-pie">
                                    <i className="ti ti-chart-pie" />
                                </a>
                            </li> */}
                        </ul>
                    </li>
                    {/* /Nav List */}
                    {/* HRMS panel */}
                    <li className="nav-item nav-item-email nav-item-box">
                        <a href={`${HRMS_URL}/login`} target='_blank' title='Login to HRMS' className='hrms-login-internal-btn'>
                            <span className='me-1'>HRMS</span> {" "} <i className="fa-solid fa-arrow-up-right-from-square"></i>
                        </a>
                    </li>
                    {/* Email */}
                    {/* <li className="nav-item nav-item-email nav-item-box">
                        <a href="#">
                            <i className="ti ti-message-circle-exclamation" />
                            <span className="badge rounded-pill">14</span>
                        </a>
                    </li> */}
                    {/* /Email */}
                    {/* Notifications */}
                    <li className="nav-item dropdown nav-item-box">
                        <a
                            href="javascript:void(0);"
                            className="nav-link"
                            data-bs-toggle="dropdown"
                        >
                            <i className="ti ti-bell" />
                            <span className="badge rounded-pill">{notificationCount}</span>
                        </a>
                        <div className="dropdown-menu dropdown-menu-end notification-dropdown">
                            <div className="topnav-dropdown-header">
                                <h4 className="notification-title">Notifications</h4>
                            </div>
                            <div className="noti-content">
                                <ul className="notification-list">
                                    {notificationArr.length ?
                                        notificationArr.map((val, index) => {
                                            return <li className="notification-message" key={index + 1} onClick={() => { readNotification(val?.id, val?.redirect_url, val) }}>
                                                <a href="#">
                                                    <div className="media d-flex">
                                                        <span className="avatar flex-shrink-0">
                                                            <img
                                                                src="/assets/img/profiles/avatar-02.jpg"
                                                                alt="Profile"
                                                            />
                                                            {val?.is_read === false && <span className="badge badge-info rounded-pill" />}
                                                        </span>
                                                        <div className="media-body flex-grow-1">
                                                            <p className="noti-details">
                                                                {val?.notification}
                                                            </p>
                                                            <p className="noti-time">{AMPMDATETIME(val?.createdAt)}</p>

                                                        </div>
                                                    </div>
                                                </a>
                                            </li>
                                        }) :
                                        <li className="notification-message">
                                            <a href="#">
                                                <div className="media d-flex">
                                                    <span className="avatar flex-shrink-0">
                                                        <img
                                                            src="/assets/img/profiles/avatar-02.jpg"
                                                            alt="Profile"
                                                        />
                                                        {/* <span className="badge badge-info rounded-pill" /> */}
                                                    </span>
                                                    <div className="media-body flex-grow-1">
                                                        <p className="noti-details">
                                                            No new notifications.
                                                        </p>

                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                    }
                                    {/* <li className="notification-message">
                                        <a href="#">
                                            <div className="media d-flex">
                                                <span className="avatar flex-shrink-0">
                                                    <img
                                                        src="/assets/img/profiles/avatar-02.jpg"
                                                        alt="Profile"
                                                    />
                                                    <span className="badge badge-info rounded-pill" />
                                                </span>
                                                <div className="media-body flex-grow-1">
                                                    <p className="noti-details">
                                                        Ray Arnold left 6 comments on Isla Nublar SOC2
                                                        compliance report
                                                    </p>
                                                    <p className="noti-time">Last Wednesday at 9:42 am</p>
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                    <li className="notification-message">
                                        <a href="#">
                                            <div className="media d-flex">
                                                <span className="avatar flex-shrink-0">
                                                    <img
                                                        src="/assets/img/profiles/avatar-03.jpg"
                                                        alt="Profile"
                                                    />
                                                </span>
                                                <div className="media-body flex-grow-1">
                                                    <p className="noti-details">
                                                        Denise Nedry replied to Anna Srzand
                                                    </p>
                                                    <p className="noti-sub-details">
                                                        “Oh, I finished de-bugging the phones, but the
                                                        system's compiling for eighteen minutes, or twenty.
                                                        So, some minor systems may go on and off for a while.”
                                                    </p>
                                                    <p className="noti-time">Last Wednesday at 9:42 am</p>
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                    <li className="notification-message">
                                        <a href="#">
                                            <div className="media d-flex">
                                                <span className="avatar flex-shrink-0">
                                                    <img alt="" src="/assets/img/profiles/avatar-06.jpg" />
                                                </span>
                                                <div className="media-body flex-grow-1">
                                                    <p className="noti-details">
                                                        John Hammond attached a file to Isla Nublar SOC2
                                                        compliance report
                                                    </p>
                                                    <div className="noti-pdf">
                                                        <div className="noti-pdf-icon">
                                                            <span>
                                                                <i className="ti ti-chart-pie" />
                                                            </span>
                                                        </div>
                                                        <div className="noti-pdf-text">
                                                            <p>EY_review.pdf</p>
                                                            <span>2mb</span>
                                                        </div>
                                                    </div>
                                                    <p className="noti-time">Last Wednesday at 9:42 am</p>
                                                </div>
                                            </div>
                                        </a>
                                    </li> */}
                                </ul>
                            </div>
                            <div className="topnav-dropdown-footer">
                                <button className="view-link me-1" onClick={() => { readAllNotifications() }} style={{ border: "none" }}>
                                    Read all
                                </button>
                                <button href="javascript:void(0);" className="clear-link ms-1" onClick={() => { deleteAllNotifications() }} style={{ border: "none" }}>
                                    Clear all
                                </button>
                            </div>
                        </div>
                    </li>
                    {/* /Notifications */}
                    {/* Profile Dropdown */}
                    <li className="nav-item dropdown has-arrow main-drop">
                        <a
                            // href="javascript:void(0);"
                            className="nav-link userset"
                            data-bs-toggle="dropdown"
                        >
                            <span className="user-info">
                                <span className="user-letter">
                                    <img src="/assets/img/profiles/avatar-20.jpg" alt="Profile" />
                                </span>
                                <span className="badge badge-success rounded-pill" />
                            </span>
                        </a>
                        <div className={`dropdown-menu menu-drop-user `}>
                            <div className="profilename">
                                <a className="dropdown-item" href="/flexichain/dashboard">
                                    <i className="ti ti-layout-2" /> Dashboard
                                </a>
                                <a className="dropdown-item" href="/flexichain/profile-page">
                                    <i className="ti ti-user-pin" /> My Profile
                                </a>
                                <a className="dropdown-item" onClick={handleLogout}>
                                    <i className="ti ti-lock" /> Logout
                                </a>
                            </div>
                        </div>
                    </li>
                    {/* /Profile Dropdown */}
                </ul>
            </div>
            {/* Mobile Menu */}
            <div className="dropdown mobile-user-menu">
                <a
                    href="javascript:void(0);"
                    className="nav-link dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                    <i className="fa fa-ellipsis-v" />
                </a>
                <div className="dropdown-menu">
                    <a className="dropdown-item" href="index.html">
                        <i className="ti ti-layout-2" /> Dashboard
                    </a>
                    <a className="dropdown-item" href="profile.html">
                        <i className="ti ti-user-pin" /> My Profile
                    </a>
                    <a className="dropdown-item" href="login.html">
                        <i className="ti ti-lock" /> Logout
                    </a>
                </div>
            </div>
            {/* /Mobile Menu */}
        </div>
    )
}

export default Navbar